function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers, Array, JSON, Object, String) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'mp-custom-event-tooltip': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
          "hook": {
            create: $helpers.createTooltip,
          },
          "attrs": __vjadeStringifyAttrsIfObj({
            placement: `bottom`,
            'max-width': `300px`,
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-custom-event-tooltip-content-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat((function() {
              var $$obj = ($helpers.getCustomEventTooltipParts());
              var $$eachNodes;
              var $$iterated = false;
              if (Array.isArray($$obj)) {
                $$eachNodes = $$obj.reduce(function($$eachNodes, part, $index) {
                  $$iterated = true;
                  return $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("span", {
                      "class": {
                        'mp-custom-event-tooltip-part-highlight': part.highlight
                      },
                    }, [__vjadeSafeCode(`${part.label} `)]));;
                    return __jade_nodes
                  }).call(this));
                }, []);
              } else {
                $$eachNodes = [];
                for (var $$objKey in $$obj) {
                  (function() {
                    var $index = $$objKey;
                    if ($$obj.hasOwnProperty($index)) {
                      $$iterated = true;
                      var part = $$obj[$index];
                      $$eachNodes = $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("span", {
                          "class": {
                            'mp-custom-event-tooltip-part-highlight': part.highlight
                          },
                        }, [__vjadeSafeCode(`${part.label} `)]));;
                        return __jade_nodes
                      }).call(this));
                    }
                  })();
                }
              }

              return $$eachNodes;
            })());;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };

  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;